import {createApp, nextTick} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/i18n/index'
import PageTemplate from "@/pages/Pc/PageTemplate.vue";
import SideHeader from "@/components/Pc/SideHeader.vue";
import TurntableCard from "@/components/Pc/TurntableCard.vue";
import SvgUse from '@/components/Pc/svg/SvgContainer.vue'

//styles
import "./styles/main.scss";

//element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'


import MetaInfo from 'vue-meta-info';

const app = createApp(App);

app.component("page-template", PageTemplate);
app.component("side-header", SideHeader);
app.component('turntable-card', TurntableCard);
app.component('svg-use', SvgUse)

app.use(store).use(router).use(ElementPlus).use(i18n).use(MetaInfo)

router.isReady().then(async () => {
  app.mount('#app')
  // Allow mounted hooks and their child components to finish updating the DOM.
  await nextTick()
  await nextTick()
  document.dispatchEvent(new Event('prerender-ready'))
})
